import { render, staticRenderFns } from "./registro_edicion_actasentrega.vue?vue&type=template&id=450936ae&scoped=true"
import script from "./registro_edicion_actasentrega.vue?vue&type=script&lang=js"
export * from "./registro_edicion_actasentrega.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_actasentrega.vue?vue&type=style&index=0&id=450936ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450936ae",
  null
  
)

export default component.exports